import { action, observable } from 'mobx';
import { toast } from "react-toastify";
import FirebaseTemplateService from "../../services/impl/firebase/FireBaseTemplateService";
import ITemplateService from "../../services/spi/ITemplateService";
import ITemplate, { ITemplateType } from "../../types/ITemplate";
import { setValueNestedObj } from '../utility';

const EmptyTemplate = {
  title: "",
  code: '',
  type: ITemplateType.page,
  seeded: false,
  lastActivity: '',
  content: '',
  uid: '',
  description: ''
} 


class TemplateStore {
  rootStore:any = null;
  templateService = {} as ITemplateService;

  @observable template:ITemplate = { 
    title: "",
    type: ITemplateType.page,
    description: '',
    content: '',
    uid: ''
  } ;
  @observable templates = [] as Array<ITemplate>;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.templateService = new FirebaseTemplateService();
  } 

  @action loadTemplates = async () => {
    try {
      this.templates = await this.templateService.getTemplates("", 8, 0);
    }
    catch(ex) {
      toast.error("Error fetching Templates!!")
    }
  }

  @action loadTemplate = async (uid: string) => {
    if (uid == undefined || uid == "") {
      this.template = EmptyTemplate;
      return this.template;
    }
    try {
      this.template = await this.templateService.getTemplate(uid);
    }
    catch(ex) {
      toast.error("Error Fetching Template Details!!")
    }
  }

  @action setAttribute = (attrName: string, attrValue: string ) => {
    setValueNestedObj(attrName, attrValue, this.template);
  }

  @action saveTemplate = async () => {
    const { uid } = this.template;
    try {
      if (uid == undefined || uid == '') {
        if (this.template.title == '') {
          toast.error("Template Creation Failed. Fill title info!!");
        }
        else{
          let temp = await this.templateService.createTemplate(this.template);
          this.loadTemplates()
        }
      }
      else {
        await this.templateService.updateTemplate(this.template);
        toast.success("Template Updated!!");
      }
    }
    catch (ex) {
      toast.error("Template Failed. Try Again Later!");
    }
  }

  @action templateBuilder = async (html:any, css: any, js:any, template: any) => {
    let content = `
      <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
      <html style="width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0;">
        <head> 
          <meta charset="UTF-8"> 
          <meta content="width=device-width, initial-scale=1" name="viewport"> 
          <meta name="x-apple-disable-message-reformatting"> 
          <meta http-equiv="X-UA-Compatible" content="IE=edge"> 
          <meta content="telephone=no" name="format-detection"> 
          <title>SALESPLAY</title> 
          <style type="text/css">
            ${css}
          </style>
        </head>
        <body>
          ${html}
        </body>
        <script type="text/js">
          ${js}
        </script>
      </html>  
      `
    
    if (template !== null && template.uid !== "") {
      template.content = content;
      await this.templateService.updateTemplate(template);
      this.loadTemplates();
      toast.success("Template Updated!!");
    }
  }

}

export default TemplateStore;